const httpErrorMessages = {
    500: 'Error Interno del Servidor',
    401: 'Acceso no Autorizado',
    403: 'Acceso Prohibido',
    404: 'Recurso no Encontrada',
    405: 'Error Interno del Servidor',
}

export default function HttpErrorPage({ statusCode }) {
    return (
        <div className='h-100 d-flex justify-content-center align-items-center'>
            <span className='fs-1 me-2'>{statusCode}</span>
            <span className='fs-5'>{httpErrorMessages[statusCode] ?? 'Error'}.</span>
        </div>
    )
}
